module.exports = __webpack_public_path__ + "static/media/registrationFinished.9d0ebccd.png";